module.exports = __webpack_public_path__ + "img/indu_active_18.0403bb03.png";